import { InputGroup, Position } from '@blueprintjs/core';
import { IFacility } from 'es/app/business-logic/domain-models/Facility';
import CopyToClipboard from 'es/app/components/buttons/CopyToClipboard';
import { useI18n } from 'es/core/hooks/useI18n';
import styles from './SiteSelector.module.css';

export function FacilityCode({ facility }: { facility?: IFacility }) {
    const { l10n } = useI18n('app/components/layout');
    const code = facility?.facilityCode;
    if (!code) return null;
    return (
        <InputGroup
            value={code}
            rightElement={
                <CopyToClipboard
                    text={code}
                    tooltipPosition={Position.BOTTOM}
                    title={l10n('action.copyFacilityCode')}
                />
            }
            className={styles.facilityCode}
            aria-label={l10n('selection.facilityCode')}
            name="site-selector-facility-code"
        />
    );
}
